export const strings = {
  bg: {
    pageNotFound:
      'Моля потърсете желания продукт в търсачката или разгледайте селекцията от продукти в менюто.',
    requiredField: 'задължително',

    //OrderPlaced
    thankYou: 'БЛАГОДАРИМ ВИ!',
    yourOrderPlaced: 'ВАШАТА ПОРЪЧКА Е ПОЛУЧЕНА.',
    orderNumber: 'Номер на поръчката',
    date: 'Дата',
    total: 'Общо',
    subtotal: 'Междинна сума',
    paymentMethodLabel: 'Начин на плащане',
    orderDetails: 'Данни на поръчката',
    shipping: 'Доставка',
    reminderTitle: 'КАКВО СЛЕДВА?',
    // Свободен текст за страницата след поръчка – редактирайте както желаете.
    // <p>...</p> е абзац, <strong>...</strong> прави текста удебелен.
    reminderMessage: `
      <p>
        <strong>Изпратихме потвърждение за Вашата поръчка на посочения от Вас
        имейл адрес.</strong> Ако не го откривате, моля проверете и папка
        <strong>„Спам“</strong> или <strong>„Нежелана поща“</strong>.
      </p>
      <p>
        <strong>Не се обаждаме допълнително за потвърждение на поръчката</strong>,
        освен ако не е необходимо уточнение. Така не Ви безпокоим с излишни
        телефонни разговори.
      </p>
      <p>
        <strong>Поръчаните от Вас продукти се изработват специално за Вас</strong>
        и не се поддържат като готови наличности. Обичайният срок за изработка е
        <strong>3–10 работни дни</strong>. <strong>Стремим се да изработим всяка
        поръчка възможно най-бързо, без това да бъде за сметка на
        качеството.</strong>
      </p>
      <p>
        Ако възникне необходимост от уточнение или има причина да не успеем да
        спазим посочения срок, <strong>ще се свържем с Вас своевременно</strong>.
      </p>
    `,
    // Shown on the thank-you page only when the order is paid by bank transfer.
    bankTransferTitle: 'ПЛАЩАНЕ ПО БАНКОВ ПЪТ',
    bankTransferIntro:
      'Поръчката е приета и ще бъде изработена и изпратена след постъпване на сумата по нашата сметка.',
    bankTransferAmount: 'Сума за превод',
    bankTransferBank: 'Банка',
    bankTransferHolder: 'Титуляр',
    bankTransferReference: 'Основание за превод',
    copy: 'Копирай',
    copied: 'Копирано',
    followUs: 'Последвайте ни в социалните мрежи',

    //Footer
    footerInfo:
      'Домашен текстил. Спално бельо - Чаршафи, Пликове, Калъфки, Чаршафи с ластик, Кръгли Чаршафи с ластик, Бебешко и детско спално бельо. Индивидуални размери по поръчка. Високо качествени естествени текстилни материали.',
    footerInfo_next:
      'Домашен текстил. Спално бельо - Чаршафи, Пликове, Калъфки, Възглавници, завивки. Хавлии. Халати. Пижами - мъжки, дамски, детски. Нощници. Бельо - дамско, мъжко. Шалтета. Кувертюри. Протектори за матраци и за възглавници. Покривки за маса. Столовки.',
    infoTabLabel: 'Информация',
    helpTabLabel: 'Помощ',
    contactUsTabLabel: 'Cвържете се с нас',
    contactForm: 'Контактна форма',
    //footer pages
    returnPage: 'Връщане на закупена стока',
    deliveryPage: 'Доставка на стоките',
    paymentTypesPage: 'Начини за плащане',
    usefulInformationPage: 'Полезна информация',
    sizeTables: 'Таблици с размери',
    returnFormPage: 'Форма за Връщане / Анулиране / Замяна',
    privacyPage: 'Защита на личните данни',
    contactsPage: 'Контакти',
    termsAndConditionsPage: 'Общи условия',

    //layout
    searchBar: 'Какво търсите?',

    //Home
    categoriesTitle: 'Разгледайте по Категория',
    categoriesSubTitle:
      'Продукти от Високо Качество, Изработени от 100% Естествени Материали и Подбрани с Внимание и Грижа за Вас',
    categoryBedSheets: 'Чаршафи',
    categoryDuvetCovers: 'Пликове',
    categoryPillowcases: 'Калъфки',
    categoryFittedSheets: 'Чаршафи с ластик',
    categoryRoundFittedSheets: 'Кръгли Чаршафи с ластик',
    categoryKidsBedSheets: 'Детски Чаршафи',
    categoryKidsDuvetCovers: 'Детски Пликове',
    categoryKidsPillowcases: 'Детски Калъфки',
    categoryKidsFittedSheets: 'Детски Чаршафи с ластик',
    squareTitle1: 'ЧАРШАФИ, ПЛИКОВЕ, КАЛЪФКИ в огромно разнообразие от РАМЕРИ, ЦВЕТОВЕ и ФОРМИ',
    squareSubTitle1:
      '- Стандартни и НЕСТАНДАРТНИ\n- Съвсем МАЛКИ и СУПЕРГОЛЕМИ\n- Едноцветни и с Принт\n- За възрастни и за деца', //Широка гама от размери на спално бельо
    squareTitle2: 'Естевствени материали',
    squareSubTitle2:
      '- 100% Натурален Памук\n\n- Хипоалергенни и безопасни\n\n- Сертифицирани по\n Oeko-Tex Standard 100',
    squareTitle3: 'Богат избор от Цветове и Стилове',
    squareSubTitle3:
      '- Флорални\n- Геометрични\n- Абстрактини\n- Двулицеви\n- Елегантни едноцветни',
    squareTitle4:
      'Спално бельо, прецизно изработено в България за теб, за да пасва перфектно на твоите любими:',
    squareSubTitle4: '- Възглавница\n- Матрак\n- Завивка',

    //product list
    productCategories: 'Категории',
    allMaterials: 'Всички',
    showingLabel: 'Показани',
    withWidth: 'с ширина',
    withHeight: 'с височина',
    withLength: 'с дължина',
    withSize: 'с размер',
    cmUnit: 'см',
    loadMoreButton: 'ВИЖТЕ ОЩЕ',
    noSearchResults1: 'Не бяха намерени резултати от търсенето за ',
    noSearchResults2: 'Моля опитайте друго търсене.',
    noMoreProducts: 'Всички налични продукти от категорията са показани.',
    see: 'Виж',

    //product view
    description: 'Описание',
    linkedProductsEyebrow: 'Разгледайте още',
    linkedProducts: 'Направете лесно своя комплект. Добавете елемент по избор:',
    scrollToTop: 'Нагоре',

    //floating chat buttons
    writeOnViber: 'Пишете ни във Viber',
    writeOnWhatsApp: 'Пишете ни в WhatsApp',
    viberNotFoundTitle: 'Viber не се отвори',
    viberNotFoundBody:
      'Изглежда, че Viber не е инсталиран на това устройство. Потърсете ни във Viber на този номер от телефона си:',
    copyNumber: 'Копирай номера',
    numberCopied: 'Номерът е копиран',
    downloadViber: 'Изтегли Viber',
    close: 'Затвори',

    //blog
    blogPage: 'Блог',
    backToBlog: 'Назад към блога',
    visitWebsite: 'Разгледай www.GoToBed.eu',

    //MiniCart
    emptyCartMessage: 'Количката Ви е празна.',
    product: 'продукт',
    products: 'продукта',
    viewCart: 'Вижте количката',
    addToCartButton: 'Добави в Количка',
    nitificationForAddedToCart: 'Добавено в количката',

    //Checkout
    yourOrderDetails: 'Вашата поръчка',

    //CheckoutForm
    personalDetails: 'Лични Данни',
    firstName: 'Име',
    surname: 'Фамилия',
    phoneNumber: 'Телефон',
    email: 'Имейл Адрес',
    deliveryAddress: 'Адрес за Доставка',
    deliveryNote:
      'Ако доставката е до ОФИС на ЕКОНТ/СПИДИ, моля напишете КОНКРЕТНИЯ ОФИС. Ако доставката е до ВАШ АДРЕС, моля напишете адреса.',
    streetAddress: 'Адрес',
    city: 'Град',
    county: 'Област',
    postcode: 'Пощенски код',
    country: 'Държава',
    bulgaria: 'България',
    note: 'Бележки към поръчката (по избор)',
    personalDetailsConfirmTnC:
      'Вашите лични данни ще бъдат използвани за обработка на вашата поръчка, както е описано в нашата Декларация за поверителност.',
    placeOrder: 'Направете Поръчка', //Поръчване
    checkoutNow: 'Към каса'
  },
  en: {},
  ru: {},
  default: {
    pageNotFound: '',

    requiredField: 'required',

    //OrderPlaced
    thankYou: '',
    yourOrderPlaced: '',
    orderNumber: '',
    date: '',
    total: '',
    subtotal: '',
    paymentMethodLabel: '',
    shipping: '',
    followUs: '',

    //Footer
    footerInfo: '',
    infoTabLabel: '',
    helpTabLabel: '',
    contactUsTabLabel: '',
    //footer pages
    returnPage: '',
    deliveryPage: '',
    paymentTypesPage: '',
    usefulInformationPage: '',
    sizeTables: '',
    returnFormPage: '',
    privacyPage: '',
    contactsPage: '',
    termsAndConditionsPage: '',

    //layout
    searchBar: '',

    //Home
    categoriesTitle: '',
    categoriesSubTitle: '',
    categoryBedSheets: '',
    categoryDuvetCovers: '',
    categoryPillowcases: '',
    categoryFittedSheets: '',
    categoryRoundFittedSheets: '',
    categoryKidsBedSheets: '',
    categoryKidsDuvetCovers: '',
    categoryKidsPillowcases: '',
    categoryKidsFittedSheets: '',
    squareTitle1: '',
    squareSubTitle1: '',
    squareTitle2: '',
    squareSubTitle2: '',
    squareTitle3: '',
    squareSubTitle3: '',
    squareTitle4: '',
    squareSubTitle4: '',

    //product list
    productCategories: '',
    allMaterials: 'All materials',
    showingLabel: 'Showing',
    withWidth: 'with width',
    withHeight: 'with height',
    withLength: 'with length',
    withSize: 'with size',
    cmUnit: 'cm',
    loadMoreButton: '',
    noSearchResults1: '',
    noSearchResults2: '',
    noMoreProducts: 'No more products available in this category.',

    //product view
    description: 'Description',
    linkedProductsEyebrow: 'Discover more',
    linkedProducts: 'Linked Products',
    scrollToTop: 'Back to top',

    //floating chat buttons
    writeOnViber: 'Message us on Viber',
    writeOnWhatsApp: 'Message us on WhatsApp',
    viberNotFoundTitle: 'Viber did not open',
    viberNotFoundBody:
      'Viber does not seem to be installed on this device. Message us on Viber from your phone using this number:',
    copyNumber: 'Copy number',
    numberCopied: 'Number copied',
    downloadViber: 'Get Viber',
    close: 'Close',

    //blog
    blogPage: 'Blog',
    backToBlog: 'Back to Blog',
    visitWebsite: 'Visit www.GoToBed.eu',

    //MiniCart
    emptyCartMessage: '',
    product: '',
    products: '',
    viewCart: '',
    addToCartButton: '',
    nitificationForAddedToCart: '',

    //Checkout
    yourOrderDetails: '',

    //CheckoutForm
    personalDetails: '',
    firstName: '',
    surname: '',
    phoneNumber: '',
    email: '',
    deliveryAdress: '',
    deliveryNote: '',
    streetAddress: '',
    city: '',
    county: '',
    postcode: '',
    country: '',
    bulgaria: '',
    note: '',
    personalDetailsConfirmTnC: '',
    placeOrder: '',
    checkoutNow: ''
  }
};
